/* The Tier Board theme (thetierboard.com). Gallery, AJAX cart drawer, mobile sticky buy bar. */
(function () {
  var d = document, root = d.documentElement;
  var money = function (c) { var v = c / 100; return '$' + (v % 1 ? v.toFixed(2) : v.toFixed(0)); };

  /* GA4 (thetierboard.com only: Ames Track loads gtag; elsewhere these are no-ops).
     Storefront: view_item, select_size, xl_nudge_click, add_to_cart, view_cart. Checkout steps and
     purchase come from the Shopify custom pixel (Sites/thetierboard/tracking/ga4-checkout-pixel.js). */
  function track(n, p) { try { if (window.gtag) window.gtag('event', n, p || {}); } catch (e) {} }
  function item(key) {
    var c = d.querySelector('.sizes [data-size="' + key + '"]'); if (!c) return null;
    return { item_id: c.dataset.sku || c.dataset.id, item_name: key === 'xl' ? 'The Tier Board XL' : 'The Tier Board', item_brand: 'The Tier Board',
      item_variant: key === 'xl' ? '60 x 50 in' : '36 x 26 in', price: +c.dataset.amount || 0, quantity: 1 };
  }
  function ec(n, key, extra) {
    var it = item(key); if (!it) return;
    var p = { currency: 'USD', value: it.price, items: [it], size: key === 'xl' ? '60x50' : '36x26' };
    for (var k in (extra || {})) p[k] = extra[k];
    track(n, p);
  }

  /* mobile gallery: "1 / 8" counter follows the swipe */
  d.querySelectorAll('.gal').forEach(function (g) {
    var row = g.querySelector('.thumbs'), out = g.querySelector('[data-gal-i]'), tick = 0;
    if (!row || !out) return;
    row.addEventListener('scroll', function () {
      if (tick) return; tick = requestAnimationFrame(function () {
        tick = 0; var b = row.querySelector('button'); if (!b) return;
        var w = b.getBoundingClientRect().width + 10; out.textContent = Math.min(row.children.length, Math.round(row.scrollLeft / w) + 1);
      });
    }, { passive: true });
  });

  /* gallery: desktop thumbs swap that size's main photo */
  d.querySelectorAll('.thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      var g = b.closest('.gal'), main = g && g.querySelector('.main');
      if (!main || window.innerWidth < 900) return;
      main.removeAttribute('srcset');
      main.src = b.dataset.src; main.srcset = b.dataset.srcset; main.alt = b.dataset.alt;
      g.querySelectorAll('.thumbs button').forEach(function (x) { x.removeAttribute('aria-current'); });
      b.setAttribute('aria-current', 'true');
    });
  });

  /* size: 36 x 26 or XL 60 x 50 (two Shopify products, one page) */
  var NOTES = { std: 'The classic size. Rows about 4.4 in tall and 28.5 in long, made for a dorm or bedroom wall.',
                xl: 'Over 3x the wall space of the 36 x 26. Rows about 9 in tall, so each tier holds two layers of photos and tickets. About as wide as a queen bed.' };
  var ADD = { std: 'Add to cart', xl: 'Add XL to cart' }, cur = 'std';
  function setSize(key, push, how) {
    var chip = d.querySelector('.sizes [data-size="' + key + '"]'); if (!chip) return;
    cur = key;
    d.querySelectorAll('[data-upsell]').forEach(function (u) { u.hidden = key === 'xl'; });
    d.querySelectorAll('.sizes .chip').forEach(function (c) { var on = c === chip; c.setAttribute('aria-checked', on); });
    d.querySelectorAll('[data-gal]').forEach(function (g) { g.hidden = g.dataset.gal !== key; });
    d.querySelectorAll('[data-price]:not(.chip)').forEach(function (n) { n.textContent = chip.dataset.price; });
    d.querySelectorAll('[data-size-label]').forEach(function (n) { n.textContent = chip.dataset.label; });
    d.querySelectorAll('[data-size-short]').forEach(function (n) { n.textContent = key === 'xl' ? 'XL' : '36 x 26'; });
    var note = d.querySelector('[data-size-note]'); if (note) note.textContent = NOTES[key];
    var id = d.querySelector('[data-atc] [name=id]'); if (id) id.value = chip.dataset.id; var pid = d.querySelector('[data-atc] [name=product-id]'); if (pid && chip.dataset.pid) pid.value = chip.dataset.pid;
    var add = d.getElementById('add'), lbl = add && add.querySelector('[data-lbl]');
    if (add) { var ok = chip.dataset.avail !== 'false'; add.disabled = !ok; add.type = ok ? 'submit' : 'button'; if (lbl) lbl.textContent = ok ? ADD[key] : 'Sold out'; }
    d.querySelectorAll('[data-pdp-xco]').forEach(function (x) { x.hidden = chip.dataset.avail === 'false'; });
    if (push && history.replaceState) { var u = new URL(location.href); if (key === 'xl') u.searchParams.set('size', 'xl'); else u.searchParams.delete('size'); history.replaceState(null, '', u); }
    if (push) { track('select_size', { size: key === 'xl' ? '60x50' : '36x26', placement: how || 'chip' }); ec('view_item', key, { placement: how || 'chip' }); }
  }
  d.querySelectorAll('.sizes .chip').forEach(function (c) { c.addEventListener('click', function () { if (c.dataset.size !== cur) setSize(c.dataset.size, true, 'chip'); }); });
  d.querySelectorAll('[data-upsell]').forEach(function (u) { u.addEventListener('click', function () { track('xl_nudge_click', { placement: 'buy_box', size: '60x50' }); setSize('xl', true, 'nudge'); var x = d.querySelector('.sizes [data-size="xl"]'); x && x.focus(); }); });
  (function () { var s = d.querySelector('[data-product]'); if (s && s.dataset.start === 'xl') { cur = 'xl'; var l = d.querySelector('#add [data-lbl]'); if (l) l.textContent = ADD.xl; } })();
  try { var q = new URLSearchParams(location.search).get('size'); if (q === 'xl' || q === 'std') setSize(q, false); } catch (e) {}
  if (d.querySelector('[data-product]')) ec('view_item', cur, { placement: 'page_load' });

  /* cart drawer */
  var drawer = d.querySelector('[data-drawer]'), items = d.querySelector('[data-items]'),
      foot = d.querySelector('[data-foot]'), total = d.querySelector('[data-total]');
  var last = null;
  function open() { last = d.activeElement; root.classList.add('open'); var c = drawer.querySelector('[data-close]'); c && c.focus(); }
  function close() { root.classList.remove('open'); last && last.focus && last.focus(); }
  d.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', close); });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  d.querySelectorAll('[data-open-cart]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); refresh().then(function (c) { open(); track('view_cart', { currency: 'USD', value: (c && c.total_price || 0) / 100 }); }); });
  });

  function render(cart) {
    d.querySelectorAll('[data-count]').forEach(function (n) { n.textContent = cart.item_count; });
    if (!cart.item_count) { items.innerHTML = '<p class="empty">Your cart is empty.</p>'; foot.hidden = true; return; }
    items.innerHTML = cart.items.map(function (it) {
      var ch = d.querySelector('.sizes [data-id="' + it.variant_id + '"]'), img = ch && ch.dataset.img ? ch.dataset.img : (it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '');
      return '<div class="it"><img src="' + img + '" alt="" width="76" height="76">' +
        '<div><b>The Tier Board' + (/XL/.test(it.product_title) ? ' XL' : '') + '</b><span>' + ((it.product_title.match(/\(([^)]+)\)/) || [, '36 x 26 in'])[1]) + ' tapestry</span>' +
        '<span class="qty"><button type="button" aria-label="One less" data-q="' + it.key + '" data-n="' + (it.quantity - 1) + '">&minus;</button>' +
        it.quantity + '<button type="button" aria-label="One more" data-q="' + it.key + '" data-n="' + (it.quantity + 1) + '">+</button></span></div>' +
        '<span class="ip">' + money(it.final_line_price) + '</span></div>';
    }).join('');
    var sid = drawer.dataset.stdId, xid = drawer.dataset.xlId, sq = 0;
    cart.items.forEach(function (it) { if (String(it.variant_id) === sid) sq += it.quantity; });
    if (sq && xid) items.insertAdjacentHTML('beforeend', '<button type="button" class="dup" data-upgrade="' + sq + '"><span class="up-t"><b>Go XL for ' + drawer.dataset.xdiff + ' more</b><span>60 x 50 in, over 3x the wall space.</span></span><span class="up-c">Upgrade</span></button>');
    total.textContent = money(cart.total_price);
    foot.hidden = false;
  }
  function refresh() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }); }
  items && items.addEventListener('click', function (e) {
    var u = e.target.closest('[data-upgrade]');
    if (u) {
      var up = {}, n = +u.dataset.upgrade; up[drawer.dataset.stdId] = 0;
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var have = 0; c.items.forEach(function (it) { if (String(it.variant_id) === drawer.dataset.xlId) have += it.quantity; });
        up[drawer.dataset.xlId] = have + n; u.disabled = true;
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: up }) });
      }).then(function (r) { return r.json(); }).then(function (c) { render(c); track('xl_upgrade', { placement: 'drawer', size: '60x50', quantity: n }); });
      return;
    }
    var b = e.target.closest('[data-q]'); if (!b) return;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: b.dataset.q, quantity: +b.dataset.n }) }).then(function (r) { return r.json(); }).then(render);
  });

  /* add to cart */
  var form = d.querySelector('[data-atc]');
  function add(placement) {
    var btn = d.getElementById('add'), lbl = btn && btn.querySelector('[data-lbl]');
    if (btn) btn.disabled = true; if (lbl) lbl.textContent = 'Adding';
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +form.querySelector('[name=id]').value, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; ec('add_to_cart', cur, { placement: placement || 'buy_box' }); return refresh(); })
      .then(function () { open(); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; if (lbl) lbl.textContent = ADD[cur] || 'Add to cart'; });
  }
  form && form.addEventListener('submit', function (e) { e.preventDefault(); add('buy_box'); });
  var barAdd = d.querySelector('[data-bar-add]');
  barAdd && barAdd.addEventListener('click', function () { form ? add('sticky_bar') : (location.href = '/'); });

  /* product page wallet button (Shop Pay / Apple Pay / PayPal, Shopify's dynamic checkout) */
  d.querySelectorAll('[data-pdp-xco]').forEach(function (x) {
    x.addEventListener('click', function () { ec('buy_now_click', cur, { placement: 'buy_box' }); }, true);
  });

  /* delivery estimate: made to order, 2 to 5 business days to print + 3 to 7 to ship = 5 to 12 business days.
     Counted from today in Indiana time; weekends and carrier holidays skipped. Christmas order-by line only when it is true. */
  (function () {
    var els = d.querySelectorAll('[data-eta]'); if (!els.length) return;
    var OFF = ['2026-11-26', '2026-12-25', '2027-01-01', '2027-01-18', '2027-02-15', '2027-05-31', '2027-07-05', '2027-09-06', '2027-10-11', '2027-11-11', '2027-11-25', '2027-12-24', '2027-12-31'];
    function iso(t) { return t.getFullYear() + '-' + ('0' + (t.getMonth() + 1)).slice(-2) + '-' + ('0' + t.getDate()).slice(-2); }
    function work(t) { var w = t.getDay(); return w && w < 6 && OFF.indexOf(iso(t)) < 0; }
    function plus(from, n) { var t = new Date(from); while (n > 0) { t.setDate(t.getDate() + 1); if (work(t)) n--; } return t; }
    var now; try { now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Indiana/Indianapolis' })); } catch (e) { now = new Date(); }
    now.setHours(12, 0, 0, 0);
    var fmt = function (t) { return t.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var a = plus(now, 5), b = plus(now, 12);
    var xmas = new Date(now.getFullYear(), 11, 23, 12), cut = new Date(xmas), xl = '';
    while (plus(cut, 12) > xmas) cut.setDate(cut.getDate() - 1);
    var days = (cut - now) / 864e5;
    if (days >= 0 && days <= 45) xl = 'Order by ' + fmt(cut) + ' for Christmas.';
    els.forEach(function (el) {
      var r = el.querySelector('[data-eta-range]'); if (r) r.textContent = fmt(a) + ' to ' + fmt(b);
      var x = el.querySelector('[data-eta-xmas]'); if (x && xl) { x.textContent = xl; x.hidden = false; }
      el.hidden = false;
    });
  })();

  /* "Get The Tier Board" at the bottom scrolls back to the buy box */
  d.querySelectorAll('[data-jump]').forEach(function (a) {
    a.addEventListener('click', function (e) { var t = d.getElementById('buy'); if (!t) return; e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  });

  /* mobile sticky bar: shows whenever the buy button is off screen (above or below), hides near the bottom CTA */
  var bar = d.querySelector('[data-bar]'), addBtn = d.getElementById('add'), again = d.querySelector('.add.again');
  if (bar && addBtn && 'IntersectionObserver' in window) {
    var seen = { add: false, again: false };
    var set = function () { var on = !seen.add && !seen.again; bar.classList.toggle('on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); barAdd.tabIndex = on ? 0 : -1; };
    new IntersectionObserver(function (es) { es.forEach(function (e) { seen[e.target === addBtn ? 'add' : 'again'] = e.isIntersecting; }); set(); })
      .observe(addBtn);
    if (again) new IntersectionObserver(function (es) { seen.again = es[0].isIntersecting; set(); }).observe(again);
  }
})();
